import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const WaIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor"><path d="M17.5 14.4c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4zM12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2z" /></svg>
);

const fmt = (n) => Math.round(Number(n) || 0).toLocaleString('fr-FR').replace(/[\u202f\u00a0,]/g, ' ');

const buildMessage = (item, link) => {
  const nom = item.prospect_nom || item.client_nom || item.prospect_entreprise || item.client_entreprise || item.entreprise || '';
  const numero = item.numero_devis || item.numero || '';
  const total = item.total_ttc ?? item.montant_total ?? item.montant;
  return [
    `Bonjour${nom ? ` ${nom}` : ''},`,
    '',
    `Veuillez trouver ci-joint notre devis${numero ? ` N° ${numero}` : ''}${total ? ` d'un montant de ${fmt(total)} FCFA` : ''}.`,
    link ? `Consultez-le ici : ${link}` : '',
    '',
    'Nous restons à votre disposition pour toute question.',
    'Cordialement,',
    "SESAM – Agence de communication",
  ].filter((l, i, arr) => l !== '' || arr[i - 1] !== '').join('\n');
};

const phoneOf = (item) => (item.prospect_telephone || item.client_telephone || item.telephone || '').replace(/[^\d]/g, '');

export function WhatsAppDevisButton({ item, kind, fetchBlob }) {
  const [busy, setBusy] = useState(false);

  const send = async () => {
    setBusy(true);
    try {
      const isMobile = window.matchMedia('(pointer: coarse)').matches;
      if (isMobile && navigator.canShare) {
        const blob = await fetchBlob(item);
        const file = new File([blob], `Devis_${item.numero_devis || item.numero || item.id}.pdf`, { type: 'application/pdf' });
        if (navigator.canShare({ files: [file] })) {
          try {
            await navigator.share({ files: [file], text: buildMessage(item, '') });
            return;
          } catch (err) {
            if (err?.name === 'AbortError') return;
          }
        }
      }
      const r = await axios.post(`${API}/api/share-links`, { kind, doc_id: item.id });
      const link = `${API}/api/public/share/${r.data.token}`;
      window.open(`https://wa.me/${phoneOf(item)}?text=${encodeURIComponent(buildMessage(item, link))}`, '_blank', 'noopener');
      toast.success('WhatsApp ouvert avec le devis');
    } catch (e) {
      if (e?.name !== 'AbortError') toast.error("Impossible d'ouvrir WhatsApp");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button onClick={send} disabled={busy} title="Envoyer le devis par WhatsApp" data-testid={`btn-whatsapp-${item.id}`}
      className="h-9 inline-flex items-center gap-1 rounded-md bg-[#25D366] hover:bg-[#1fb955] text-white text-xs font-semibold px-2 transition-colors disabled:opacity-60">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <WaIcon />} WhatsApp
    </button>
  );
}
